<template>
  <v-form>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="items"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.per_address="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              class="d-inline-block text-truncate"
              style="max-width: 130px;"
              v-on="on"
            >
              {{ item.per_address }}
            </span>
          </template>
          <span style="max-width: 500px; float: left; word-wrap: break-word;">{{
            item.per_address
          }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.types="{ item }">
        <v-chip
          v-for="type in item.types"
          :key="type.id"
          class="mr-1"
          color="primary"
          x-small
          dark
          outlined
          >{{ type.name }}
        </v-chip>
      </template>

      <template v-slot:item.status="{ item }">
        <v-chip dark :color="item.status_color">
          {{ item.status }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <action-slot-component
          :item="item"
          route-name="companies.show"
          open-in-new-window
          :route-params="{ id: item.id }"
          @show="$emit('show', item)"
        />
      </template>
    </v-data-table>
  </v-form>
</template>

<script>
import listItems from '@/modules/_global/mixins/list-items';
import ActionSlotComponent from '@/modules/_global/_components/ActionSlotComponent.vue';

export default {
  name: 'CompanyList',
  components: { ActionSlotComponent },

  mixins: [listItems],

  data: () => ({}),

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.NAME'),
          value: 'name'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'types',
          sortable: false
        },
        {
          text: this.$t('PROFILE.STREET'),
          value: 'street'
        },
        {
          text: this.$t('PROFILE.ZIP'),
          value: 'zip'
        },
        {
          text: this.$t('PROFILE.CITY'),
          value: 'city'
        },
        {
          text: this.$t('COMPANIES.PER_ADDRESS'),
          value: 'per_address'
        },
        {
          text: this.$t('PROFILE.STATUS'),
          value: 'status'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ];
    }
  },

  methods: {}
};
</script>
